export interface DefaultCard {
  id: string;
  category: string;
  icon: string;
  label: string;
  subtext: string;
  sort_order: number;
}

const uuid = (n: number): string => {
  const hex = n.toString(16).padStart(12, '0');
  return `00000000-0000-0000-0000-${hex}`;
};

export const DEFAULT_CARDS: DefaultCard[] = [
  // energy ×5
  { id: uuid(1),  category: 'energy',       icon: '🪫', label: 'Battery Low',       subtext: 'Running low — need to recharge soon.', sort_order: 1 },
  { id: uuid(2),  category: 'energy',       icon: '🌙', label: 'Need Quiet',        subtext: 'Volume down. Low stimulation, please.', sort_order: 2 },
  { id: uuid(3),  category: 'energy',       icon: '🤯', label: 'Sensory Overload',  subtext: 'Too much input. Need to decompress.',  sort_order: 3 },
  { id: uuid(4),  category: 'energy',       icon: '💤', label: 'Running on Empty',  subtext: 'Out of spoons. Be gentle with me.',    sort_order: 4 },
  { id: uuid(5),  category: 'energy',       icon: '🧘', label: 'Recharging',        subtext: 'Resetting. Back online soon.',          sort_order: 5 },

  // needs ×5
  { id: uuid(6),  category: 'needs',        icon: '🌿', label: 'Need Space',        subtext: 'Some alone time would help.',           sort_order: 1 },
  { id: uuid(7),  category: 'needs',        icon: '🫂', label: 'Need a Hug',        subtext: 'A long one would be perfect.',          sort_order: 2 },
  { id: uuid(8),  category: 'needs',        icon: '🥗', label: 'Need Food',         subtext: 'Hungry. A snack or meal would help.',   sort_order: 3 },
  { id: uuid(9),  category: 'needs',        icon: '🤝', label: 'Need Help',         subtext: 'Could use a hand with something.',      sort_order: 4 },
  { id: uuid(10), category: 'needs',        icon: '🥤', label: 'Need Water',        subtext: 'Could you bring me a drink?',           sort_order: 5 },

  // availability ×4
  { id: uuid(11), category: 'availability', icon: '🛑', label: 'Busy',              subtext: 'Mid-task. Not available right now.',    sort_order: 1 },
  { id: uuid(12), category: 'availability', icon: '🚦', label: 'Free',              subtext: 'Around and available.',                 sort_order: 2 },
  { id: uuid(13), category: 'availability', icon: '📞', label: 'In a Meeting',      subtext: 'On a call. Will check in after.',       sort_order: 3 },
  { id: uuid(14), category: 'availability', icon: '🎧', label: 'Heads Down',        subtext: 'Deep focus mode. Interrupt only if urgent.', sort_order: 4 },

  // emotional ×5
  { id: uuid(15), category: 'emotional',    icon: '😰', label: 'Anxious',           subtext: 'Mind is racing. Could use steadying.',  sort_order: 1 },
  { id: uuid(16), category: 'emotional',    icon: '😢', label: 'Sad',               subtext: 'Feeling low. Sit with me a moment.',    sort_order: 2 },
  { id: uuid(17), category: 'emotional',    icon: '😵', label: 'Overwhelmed',       subtext: 'Everything feels like too much.',       sort_order: 3 },
  { id: uuid(18), category: 'emotional',    icon: '😡', label: 'Frustrated',        subtext: 'Hit a wall. Not at you, just stuck.',   sort_order: 4 },
  { id: uuid(19), category: 'emotional',    icon: '😌', label: 'Content',           subtext: 'Settled. Things are okay.',             sort_order: 5 },

  // connection ×5
  { id: uuid(20), category: 'connection',   icon: '💭', label: 'Thinking of You',   subtext: 'You crossed my mind just now.',         sort_order: 1 },
  { id: uuid(21), category: 'connection',   icon: '💕', label: 'Miss You',          subtext: 'Wishing you were here.',                sort_order: 2 },
  { id: uuid(22), category: 'connection',   icon: '✨', label: 'Proud of You',      subtext: 'You\u2019re doing the thing. I see it.', sort_order: 3 },
  { id: uuid(23), category: 'connection',   icon: '❤️', label: 'Love You',          subtext: 'Just that.',                            sort_order: 4 },
  { id: uuid(24), category: 'connection',   icon: '🌸', label: 'Just Because',      subtext: 'No reason. Sending warmth.',            sort_order: 5 },
];
